import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import AuthWrapper from './components/AuthWrapper';
import Layout from './components/layout/Layout';
import SmartSearch from './pages/SmartSearch';
import Profiles from './pages/Profiles';
import ProfileEdit from './pages/ProfileEdit';
import QueryResults from './pages/QueryResults';
import Redeem from './pages/Redeem';
import ImportUrls from './pages/ImportUrls';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthWrapper>
      <LanguageProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<SmartSearch />} />
              <Route path="/profiles" element={<Profiles />} />
              <Route path="/profiles/edit/:profileId" element={<ProfileEdit />} />
              <Route path="/query/:queryId" element={<QueryResults />} />
              <Route path="/redeem" element={<Redeem />} />
              <Route path="/import" element={<ImportUrls />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </LanguageProvider>
    </AuthWrapper>
  </React.StrictMode>
); 